import React, {useEffect, useState} from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Dialog,
    TextField, Grid, CardContent, CardHeader, Card, CardActions, Typography, IconButton
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import {formatDateUS} from "../../../../helpers/utils";
import NotesService from "../../services/NotesService";
import {Skeleton} from "@material-ui/lab";
import {useSelector} from "react-redux";

const NotesDialog = ({body, label, adminNotes, ...props}) => {
    const [note, setNote] = useState('');
    const [notes, setNotes] = useState([]);
    const [fetching, setFetching] = useState(false);
    const session = useSelector((state) => state.adminLogin.adminUserSession);

    useEffect(() => {
        if(adminNotes.open) {
            fetchNotes();
        } else {
            setNote(null);
        }
    }, [adminNotes.open]);

    const fetchNotes = async () => {
        setFetching(true);
        const response = await adminNotes.fetch();
        const {notes} = response.data;
        setNotes(notes.map((note) => note.data.attributes));
        if (props.onChangeNotes) props.onChangeNotes(notes.length)
        setFetching(false);
    }

    const onDelete = async (noteId) => {
        await NotesService.delete(noteId, session);
        fetchNotes();
    }
    const onSave = async (_event) => {
        await adminNotes.save(note);
        fetchNotes();
        setNote("");
    }

    const onClose = () => {
        adminNotes.setOpen(false)
    }

    return <Dialog open={adminNotes.open} onClose={onClose} aria-labelledby="form-dialog-title" fullWidth className={"dialog"}>
        <DialogTitle id="form-dialog-title" disableTypography>
            <h4 className={"dialog-title"}>{label}</h4>
        </DialogTitle>
        <DialogContent dividers>
            <DialogContentText>
                {body}
            </DialogContentText>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Notes"
                        variant="outlined"
                        name={'notes'}
                        onChange={(event) => setNote(event.target.value)}
                        value={note}
                        multiline={true}
                        minRows={4}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button onClick={onSave} className="create">
                        Save
                    </Button>
                </Grid>

                {
                    fetching ? <Skeleton animation='pulse' variant='rect' height='200px' width='100%' component='div' /> : <>
                        { (notes.length > 0) && <>
                            <Grid item xs={12}>
                                <DialogContentText>
                                    Notes
                                </DialogContentText>
                            </Grid>

                            {
                                notes.map((noteData) => (<Grid item xs={12} key={noteData.id}>
                                    <Card elevation={3} raised>
                                        <CardHeader
                                            title={<Typography variant="body1" color="textSecondary" component="p">
                                                By: {noteData?.author_name}
                                            </Typography>}
                                            subheader={<Typography variant="body1" color="textSecondary" component="p">
                                                {formatDateUS(noteData?.updated_at)}
                                            </Typography>}
                                        />
                                        <CardContent>
                                            <Typography variant="h5" color="textPrimary" component="p">
                                                {noteData?.body}
                                            </Typography>
                                        </CardContent>
                                        <CardActions disableSpacing style={{justifyContent: "flex-end"}}>
                                            {/*<IconButton aria-label="edit" onClick={toggleEdit}>
                                            <EditIcon />
                                        </IconButton>*/}
                                            <IconButton aria-label="delete" onClick={() => onDelete(noteData.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </CardActions>
                                    </Card>
                                </Grid>))
                            }
                        </>
                        }
                    </>
                }
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>
                Close
            </Button>
        </DialogActions>
    </Dialog>
}

export default NotesDialog;